import * as React from 'react';
import { SVGProps } from 'react';

const SvgScissors = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    fill="none"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      d="m23.948 18.741-3.296-3.295 3.356-3.366 6.163-5.347a1.162 1.162 0 0 1 1.888.578 1.17 1.17 0 0 1 .583 1.893l-5.394 6.242-3.3 3.295Zm0-3.295.699-.7-.7.7Z"
    />
    <circle
      cx={7.9}
      cy={25.8}
      r={2.75}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <circle
      cx={13.8}
      cy={31.5}
      r={2.75}
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="M10 27.5 20.5 18M12 29.5l9.5-11"
    />
    <path
      fill="currentColor"
      d="M15.5 28a1.16 1.16 0 0 1-.83-.34l-2.844-2.84a1.165 1.165 0 0 1 1.65-1.645l2.85 2.83a1.175 1.175 0 0 1-.379 1.905 1.14 1.14 0 0 1-.447.09Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m13.359 7.077 2.475 2.476m-6.391 2.926 3.382.906m6.645-9.01.906 3.382m7.997 18.165 2.476 2.475m-6.867-.589.91 3.396m6.632-9.233 3.396.91"
    />
    <path
      fill={props.fill}
      d="m27.243 15.441-5.775 5.771-3.296-3.296 2.461-2.461 6.61-.014Z"
    />
  </svg>
);

export default SvgScissors;
